module.exports = __webpack_public_path__ + "img/prev-btn.79372a28.svg";